"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { resolveVinteraTopNavigationContext } from "../../lib/ui/navigationContext";
import { vinteraBusinessIdentity, vinteraSupportMailto, vinteraSupportPhoneHref } from "../../lib/businessIdentity";

export default function Footer() {
  const pathname = usePathname();
  const context = resolveVinteraTopNavigationContext(pathname);
  const homeHref = context === "staff_workspace" ? "/admin" : context === "customer_portal" ? "/portal" : "/";
  const contactHref = context === "customer_portal" ? "/portal/help" : "/contact";

  return (
    <footer className="border-t border-[var(--vintera-border)] bg-white">
      <div className="mx-auto grid max-w-6xl gap-5 px-4 py-7 text-sm text-[var(--vintera-muted)] sm:px-6 md:grid-cols-[minmax(0,1fr)_auto] md:items-center">
        <div>
          <Link href={homeHref} aria-label="Vintera Health home" className="inline-flex min-h-11 items-center">
            <Image
              src="/vintera-logo.jpg"
              alt="Vintera Health"
              width={1206}
              height={344}
              loading="eager"
              className="h-auto w-[190px] sm:w-[220px]"
            />
          </Link>
          <p className="mt-1">
            Pharmaceutical wholesale distribution for approved healthcare businesses.
          </p>
          <div className="mt-2 flex max-w-3xl flex-wrap items-center gap-x-4 gap-y-1 sm:gap-x-5">
            <a href={vinteraSupportMailto()} className="inline-flex min-h-9 items-center break-all hover:text-[var(--vintera-navy)] hover:underline">{vinteraBusinessIdentity.supportEmail}</a>
            <a href={vinteraSupportPhoneHref()} className="inline-flex min-h-9 items-center whitespace-nowrap hover:text-[var(--vintera-navy)] hover:underline"><span className="mr-1 font-semibold">Phone</span>{vinteraBusinessIdentity.phoneDisplay}</a>
            <span className="inline-flex min-h-9 items-center whitespace-nowrap"><span className="mr-1 font-semibold">Fax</span>{vinteraBusinessIdentity.faxDisplay}</span>
          </div>
          <p className="mt-1.5 font-medium text-[var(--vintera-sage-dark)]">Located in Staten Island, NY</p>
        </div>
        {context !== "staff_workspace" ? (
          <div className="flex flex-wrap gap-4 font-semibold">
            {context === "public" ? (
              <Link href="/apply" className="inline-flex min-h-11 items-center transition hover:text-[var(--vintera-navy)]">
                Apply
              </Link>
            ) : null}
            <Link href={contactHref} className="inline-flex min-h-11 items-center transition hover:text-[var(--vintera-navy)]">
              Contact
            </Link>
            {context === "public" ? (
              <Link href="/admin/login" className="inline-flex min-h-11 items-center transition hover:text-[var(--vintera-navy)]">
                Admin
              </Link>
            ) : null}
          </div>
        ) : null}
      </div>
    </footer>
  );
}
